// App.js
import React from "react";
import { useState, useEffect } from "react";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Download from "yet-another-react-lightbox/plugins/download";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Pagination from "./components/Pagination";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [photos, setPhotos] = useState([]);

  const [fullPhotos, setFullPhotos] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [index, setIndex] = useState(-1);
  const apiURL = `${window.global.root_url}/wp-json/leib/v1/albums/${window.global.postID}/photos`;
  let perPage = 9;

  const fetchPhotos = async () => {
    const photoArray = [];
    const fullPhotoArray = [];

    const response = await fetch(
      `${apiURL}?page=${currPage}&per_page=${perPage}`
    );
    const data = await response.json();

    console.log(data);

    data.photos.forEach((photo) => {
      photoArray.push({
        src: photo.sizes.medium,
        alt: photo.title,
        width: 4,
        height: 3,
      });
      fullPhotoArray.push({
        src: photo.url,
        alt: photo.title,
        width: "800",
        height: "800",
        imageFit: "contain",
        title: photo.caption,
      });
    });

    setPhotos(photoArray);
    setFullPhotos(fullPhotoArray);
    setTotalPages(data.total_pages);
    setIsLoading(false);
  };

  const renderPhotos = () => {
    if (!photos) return <p>No photos found. Please try again later.</p>;
    console.log(photos);
    return (
      <>
        {" "}
        <PhotoAlbum
          rowConstraints={{ maxPhotos: 3 }}
          layout="rows"
          photos={photos}
          onClick={({ index }) => setIndex(index)}
          renderContainer={({ containerRef, containerProps, children }) => (
            <div className="photo" ref={containerRef} {...containerProps}>
              {children}
            </div>
          )}
        />
        <div className="lightbox-container">
          <Lightbox
            slides={fullPhotos}
            open={index >= 0}
            index={index}
            close={() => setIndex(-1)}
            // enable optional lightbox plugins
            plugins={[Captions, Download, Fullscreen, Slideshow]}
          />
        </div>
      </>
    );
  };

  useEffect(() => {
    setIsLoading(true);
    fetchPhotos();
  }, [currPage]);

  return (
    <div className="App">
      {isLoading ? (
        <div className="loader"></div>
      ) : (
        <>
          <div className="album">{renderPhotos()}</div>
          <Pagination
            currPage={currPage}
            setCurrPage={setCurrPage}
            totalPages={totalPages}
          />
        </>
      )}
    </div>
  );
}

export default App;
